import { CarUser } from '../models/car-user.enum';
import type { ICarInformation } from '../models/car-information.model';
import { ValueDepreciationScenario } from '../models/value-depreciation-scenario.enum';
import { ConfigurationService } from '../../../services/configuration.service';

export const CarInformationDefault: ICarInformation = {
  modelYear: undefined,
  fuelType: undefined,
  carType: undefined,
  carUser: CarUser.CarOwner,
  leasingCostPerMonth: undefined,
  estimatedCarValueDeprication: ValueDepreciationScenario.Normal,
  variableDepreciationPercentage: 0,
  insuranceCostPerYear: Number(ConfigurationService.get('pricecalculatorpage.carinformation.insurancedefault')),
  drivingDistancePerYearKm: Number(ConfigurationService.get('pricecalculatorpage.carinformation.drivingdistancedefault')),
};
